<script setup>
  const props = defineProps({
    label: String,
  });
</script>

<template>
  <div class="search-item">
    <label>{{ props.label }}</label>
    <slot />
  </div>
</template>

<style lang="scss">
  .search-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.375rem;
    flex: 0 1 auto;
    min-width: 160px;
    label {
      color: var(--smoe-gray-800);
      font-size: 0.9375rem;
      font-weight: 700;
      line-height: 1.25;
      flex-shrink: 0;
      position: relative;
      display: inline-flex;
      align-items: center;
      & + .n-input {
        max-width: 180px;
      }
    }
  }
</style>
